const PAYMENT_URL_TTL = 20 * 60 * 1000;

export const selectOrdersState = (state) => state.orders;

export const selectIsPutOrderLoading = (state) => state.orders?.loading || false;

export const selectOrderError = (state) => state.orders?.error || null;

export const selectLastOrder = (state) => state.orders?.lastOrder || null;

export const selectPaymentUrl = (state, orderId) => {
    const entry = state.orders?.paymentUrls?.[String(orderId)];
    if (!entry) return null;
    if (Date.now() - entry.createdAt > PAYMENT_URL_TTL) return null;
    return entry.url;
};

export const selectLastOrderNumber = (state) => state.orders?.lastOrder?.order_number || null;

export const selectLastOrderId = (state) => state.orders?.lastOrder?.id || null;

export const selectLastOrderStatus = (state) => state.orders?.lastOrder?.status || null;

export const selectLastOrderTotal = (state) => state.orders?.lastOrder?.total || null;

export const ordersSelectors = {
    selectOrdersState,
    selectIsPutOrderLoading,
    selectOrderError,
    selectLastOrder,
    selectLastOrderNumber,
    selectLastOrderId,
    selectLastOrderStatus,
    selectLastOrderTotal,
    selectPaymentUrl,
};

export default ordersSelectors;